import { motion } from "framer-motion";
import { ChapterHeading } from "@/components/ChapterHeading";
import { TIMELINE } from "@/data/profile";

export const Timeline = () => (
  <section id="career" data-testid="career-section" className="border-t hairline py-24 md:py-40 bg-[var(--surface)]">
    <div className="px-6 md:px-12">
      <ChapterHeading num="06" label="Career" title={["Roustabout to", "superintendent"]} />
    </div>
    <div className="mt-16 md:mt-24 border-t hairline">
      {TIMELINE.map((t, i) => (
        <motion.div
          key={t.years}
          data-testid={`timeline-${i}`}
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-5% 0px" }}
          transition={{ duration: 0.7, delay: i * 0.05, ease: [0.76, 0, 0.24, 1] }}
          className="group grid grid-cols-12 gap-4 md:gap-6 px-6 md:px-12 py-8 md:py-10 border-b hairline relative hover:bg-[var(--bg)] transition-colors duration-400"
        >
          <span className="absolute left-0 top-0 bottom-0 w-1 bg-[var(--accent)] scale-y-0 origin-top transition-transform duration-500 ease-out group-hover:scale-y-100" />
          <div className="col-span-12 md:col-span-2 eyebrow pt-1">{t.years}</div>
          <div className="col-span-12 md:col-span-5">
            <h3 className="font-display uppercase text-3xl md:text-4xl leading-none">{t.role}</h3>
            <p className="mt-2 text-sm text-muted">
              {t.company} <span className="text-[var(--accent)]">·</span> {t.place}
            </p>
          </div>
          <p className="col-span-12 md:col-span-4 md:col-start-9 text-sm text-muted leading-relaxed pt-1">{t.note}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
